module.exports = __webpack_public_path__ + "img/team-1.8b58644f.jpg";